import cx from 'classnames'
import { CSSProperties } from 'react'

interface CheckboxTickProps {
  isChecked: boolean
  className?: string
  pathStyle?: CSSProperties
}

const CheckboxTick = ({
  isChecked,
  className,
  pathStyle,
}: CheckboxTickProps) => (
  <svg
    viewBox="0 0 100 100"
    className={cx(
      'w-[20px] h-[20px] block flex-none mr-3 p-1 pointer-events-none border transition-colors duration-150',
      className,
    )}
  >
    <path
      fill="none"
      strokeWidth="13"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      d="M12.1 52.1l24.4 24.4 53-53"
      className={cx(
        'stroke-current text-current',
        'transition-all duration-150 delay-0',
        'stroke-dasharray-120',
        {
          'stroke-dashoffset-120': !isChecked,
          'stroke-dashoffset-0 delay-150': isChecked,
        },
      )}
      style={pathStyle}
    />
  </svg>
)

export default CheckboxTick
